import { II18n } from '@bingads-webui-campaign-react/ads-studio-app-shared-components';

export function getI18n(i18n: II18n): II18n {
  return {
    p$data: i18n.p$data,
    getLocale: () => i18n.getLocale(),
    getString: (name: string, param?: any) => i18n.getString(name, param),
    getToday: (param: { timeZone?: string }) => i18n.getToday(param),
    getFirstDayOfWeek: () => i18n.getFirstDayOfWeek(),
    getDayOfWeek: (value: number, param?: any) => i18n.getDayOfWeek(value, param),
    formatCivilDate: (date: string, param: { timeZone: string | null, raw: string }) => i18n.formatCivilDate(date, param),
    formatDate: (date: string, param: { timeZone: string | null, raw: string }) => i18n.formatDate(date, param),
    formatDecimal: (value: number, param?: any) => i18n.formatDecimal(value, param),
    formatPercentToFixed: (value: number, param: any) => i18n.formatPercentToFixed(value, param),
    parseCivilDate: (date: string, param: { timeZone: string | null, raw: string }) => i18n.parseCivilDate(date, param),
    parseDate: (date: string, param: { timeZone: string | null, raw: string }) => i18n.parseDate(date, param),
    formatDecimalToFixed: (value: number, param?: any) => i18n.formatDecimalToFixed(value, param),
  };
}
